/**
 * Карта статусов платежа → метка (RU) + тон (совпадает с классами `.pw-status--*` в theme.css).
 * Цвета берутся из CSS-переменных темы, здесь только семантика.
 */

import type { PaymentStatus } from '../../../lib/types';

export type StatusTone =
  | 'overdue'
  | 'due-today'
  | 'paid'
  | 'partially-paid'
  | 'scheduled'
  | 'due-tomorrow'
  | 'cancelled';

export interface StatusMeta {
  label: string;
  tone: StatusTone;
}

export const STATUS_META: Record<PaymentStatus, StatusMeta> = {
  OVERDUE: { label: 'Просрочен', tone: 'overdue' },
  DUE_TODAY: { label: 'Сегодня', tone: 'due-today' },
  PAID: { label: 'Оплачен', tone: 'paid' },
  PARTIALLY_PAID: { label: 'Частично', tone: 'partially-paid' },
  SCHEDULED: { label: 'Ожидается', tone: 'scheduled' },
  DUE_TOMORROW: { label: 'Завтра', tone: 'due-tomorrow' },
  CANCELLED: { label: 'Отменён', tone: 'cancelled' },
};

/** Порядок статусов для выпадающего фильтра. */
export const STATUS_ORDER: PaymentStatus[] = [
  'OVERDUE',
  'DUE_TODAY',
  'DUE_TOMORROW',
  'SCHEDULED',
  'PARTIALLY_PAID',
  'PAID',
  'CANCELLED',
];
